





























































import MainMixin from '@/product/mixins/main'
import EstimatedShippingAccordions from '@/product/components/EstimatedShippingAccordions.vue'
import ProductSizeMobile from '@/product/components/ProductSizeMobile.vue'
import SizeDetailAccordion from '@/product/components/SizeDetailAccordion.vue'
import SeriesProductsMobile from '@/product/components/SeriesProductsMobile.vue'
import SimilarProducts from '@/product/components/SimilarProducts.vue'

export default MainMixin.extend({
  components: {
    EstimatedShippingAccordions,
    ProductSizeMobile,
    SizeDetailAccordion,
    SeriesProductsMobile,
    SimilarProducts
  },
  computed: {
    unpublished(): boolean {
      return this.$store.getters.isProductUnpublished
    }
  }
})
